// index.pc.js（PC用）
import { initPcBase } from "./base/pcBase.js";
import { revealSection, revealOnLoad, revealSequence } from "./core/fade.js";
// import { initMarqueeText, initVerticalSliders } from "./features/marquee.js";
// Optional:
// import { initCareerAccordion } from "./features/accordion.js";
// import { initModal } from "./features/modal.js";
// import { setupTabs, activateTabFromURL } from "./features/tabs.js";

document.addEventListener("DOMContentLoaded", () => {
  // ベース初期化（ヘッダー/アンカー/メガナビ/スクロール基盤）
  const disposeBase = initPcBase();

  // フェード系
  revealOnLoad(".js-fv .reveal", { base: 0.2, step: 0.06 });
  revealSection(".reveal");
  revealSequence(".js-stagger", ".reveal", { rootMargin: "0% 0% -12% 0", threshold: 0 }, { base: 0, step: 0.08 });

  // マーキー / 縦スライダー
  // initMarqueeText();
  // initVerticalSliders();

  // 任意機能
  // initCareerAccordion();
  // initModal();
  // setupTabs(); activateTabFromURL();

  // 破棄が必要なら：disposeBase();
});
